import { Controller } from 'react-hook-form'
import {
  FormControl,
  IconButton,
  InputAdornment,
  TextField
} from '@mui/material'
import {
  SelectMultilineSkeleton,
  SelectSkeleton
} from '@components/common/Skeletons'

// import { ErrorOutline as ErrorIcon } from '@mui/icons-material'

export const TextFieldItemController = ({
  errorMessage,
  fullWidth = true,
  control,
  name,
  defaultValue,
  label,
  ...props
}) => {
  const isError = Boolean(errorMessage)

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => (
        <FormControl fullWidth={fullWidth} margin="dense">
          <TextField
            variant="outlined"
            size="small"
            label={label}
            error={isError}
            helperText={isError && errorMessage}
            {...props}
            {...field}
          />
        </FormControl>
      )}
    />
  )
}

const TextFieldItem = ({
  field,
  errorMessage,
  fullWidth = true,
  focused = false,
  required = false,
  endAdornmentContent = null,
  endAdornmentAction = '',
  endAdornmentClick = () => null,
  selectOnFocus = false,
  loading = false,
  ...props
}) => {
  delete props.fieldState
  delete props.formState
  const isError = Boolean(errorMessage)
  return (
    <>
      {!loading && (
        <FormControl fullWidth={fullWidth} margin="dense">
          <TextField
            autoFocus={focused}
            required={required}
            error={isError}
            helperText={isError && errorMessage}
            // InputProps={{
            //   endAdornment: (
            //     // Take a look to theme .MuiTextField + .MuiInputAdornment (position: absolute + relative)
            //     <InputAdornment position="end">
            //       <IconButton disableRipple>
            //         {isError && <ErrorIcon color="error" />}
            //       </IconButton>
            //     </InputAdornment>
            //   )
            // }}
            InputProps={
              endAdornmentContent && {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      edge="end"
                      type={endAdornmentAction}
                      onClick={endAdornmentClick}
                    >
                      {endAdornmentContent}
                    </IconButton>
                  </InputAdornment>
                )
              }
            }
            onFocus={event => (selectOnFocus ? event.target.select() : null)}
            {...field}
            {...props}
          />
        </FormControl>
      )}
      {loading && props.multiline && <SelectMultilineSkeleton />}
      {loading && !props.multiline && <SelectSkeleton />}
    </>
  )
}

export default TextFieldItem
